import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TicketDTO } from 'src/app/DTO/TicketDTO';
import { TicketPurchaseDTO } from 'src/app/DTO/tickets/TicketPurchaseDTO';
import { ApiService } from 'src/app/services/api.service';
import { API_URL } from 'src/environments/environment';
import {CustomFieldDTO} from "../../../../../DTO/CustomFieldDTO";
import { TicketFreePlacesDTO } from 'src/app/DTO/tickets/TicketFreePlacesDTO';
import { DateTime } from 'luxon';
import { TicketPurchaseRequest } from 'src/app/DTO/tickets/requests/TicketPurchaseRequest';
import { TicketCouponPreviewResponseDTO } from 'src/app/DTO/tickets/TicketCouponPreviewResponseDTO';
import { TicketPurchaseDetailDTO } from 'src/app/DTO/tickets/TicketPurchaseDetailDTO';

@Injectable({
  providedIn: 'root'
})
export class TicketsService {

  constructor(private api: ApiService,
              private httpClient: HttpClient
  ) { }

  public getTicketById(communityId: number, ticketId: number): Observable<TicketDTO> {
    const url = `${API_URL}/v2/Communities/${communityId}/Modules/Tickets/${ticketId}`;
    return this.api.get(url);
  }


  public getAvailability(communityId: number, id: number): Observable<number> {
    return this.api.get(`${API_URL}/v2/Communities/${communityId}/Modules/Tickets/${id}/availability`);
  }

  public getAvailabilityV2(communityId: number, id: number): Observable<TicketFreePlacesDTO>;
  public getAvailabilityV2(communityCode: string, id: number, includeWaitingList?: boolean, accessCode?: string): Observable<TicketFreePlacesDTO>;
  public getAvailabilityV2(communityCodeOrId: string | number, id: number, includeWaitingList?: boolean, accessCode?: string): Observable<TicketFreePlacesDTO> {
    const base = `${API_URL}/v2.1/Communities/${communityCodeOrId}/Modules/Tickets/${id}/availability`;
    const params: string[] = [];
    if (includeWaitingList !== undefined) params.push(`includeWaitingList=${includeWaitingList}`);
    if (accessCode != null && accessCode !== '') params.push(`accessCode=${encodeURIComponent(accessCode)}`);
    const url = params.length ? `${base}?${params.join('&')}` : base;
    return this.api.get(url);
  }

  public purchase(communityCode: string, id: number, userdata: any, details: any[] , customFields: CustomFieldDTO[], token: string, rgpdAcceptedDate?: DateTime): Observable<any> {
    const rgpdAcceptedDateFormatted = rgpdAcceptedDate ? rgpdAcceptedDate.toISO({ suppressMilliseconds: true, includeOffset: false }) : null;
    return this.httpClient.post(`${API_URL}/v2.1/Communities/${communityCode}/Modules/Tickets/${id}/purchase?reservationToken=${token}`, {
        details,
        userdata,
        customFields,
        termsAcceptedDate: rgpdAcceptedDateFormatted,
    });
  }

  public purchaseMultiple(communityCode: string, id: number, request: TicketPurchaseRequest, token: string, accessCode?: string | null): Observable<any> {
    let url = `${API_URL}/v2/Communities/${communityCode}/Modules/Tickets/${id}/purchase-multiple?reservationToken=${token}`;
    if (accessCode) {
      url += `&accessCode=${encodeURIComponent(accessCode)}`;
    }
    return this.httpClient.post(url, request);
  }

  public previewCoupon(
    communityCode: string,
    ticketId: number,
    code: string,
    details: Pick<TicketPurchaseDetailDTO, 'ticketPriceId' | 'quantity'>[]
  ): Observable<TicketCouponPreviewResponseDTO> {
    const url = `${API_URL}/v2/Communities/${communityCode}/Modules/Tickets/${ticketId}/coupons/preview`;
    return this.httpClient.post<TicketCouponPreviewResponseDTO>(url, { code, details });
  }

  public checkPayment(communityCode: string, uuid: string): Observable<any> {
    return this.api.get(`${API_URL}/v2/Communities/${communityCode}/Modules/Tickets/my/${uuid}/checkPayment`);
  }

  public getMyTicket(communityCode: string, uuid: string): Observable<TicketPurchaseDTO> {
    return this.api.get(`${API_URL}/v2/Communities/${communityCode}/Modules/Tickets/my/${uuid}`);
  }

  public getMyTicketAnonymous(communityCode: string, uuid: string): Observable<TicketPurchaseDTO[]> {
    return this.api.get(`${API_URL}/v2/Communities/${communityCode}/Modules/Tickets/my-anonymous/${uuid}`);
  }

  public reservePlaces(communitycode: string, ticketId: number, details: any[], accessCode?: string | null): Observable<any> {
    let url = `${API_URL}/v2/Communities/${communitycode}/Modules/Tickets/${ticketId}/reserved-places`;
    if (accessCode) {
      url += `?accessCode=${encodeURIComponent(accessCode)}`;
    }
    return this.httpClient.post(url, { details });
  }

  public cancelReservedPlaces(communityCode: string, ticketId: number, token: string): Observable<any> {
    return this.httpClient.delete(`${API_URL}/v2/Communities/${communityCode}/Modules/Tickets/${ticketId}/reserved-places?reserveToken=${token}`);
  }
  public cancelTicket(communityCode: string, uuid: string): Observable<any> {
    return this.httpClient.get(`${API_URL}/v2/Communities/${communityCode}/Modules/Tickets/cancelPurchase/${uuid}`);
  }
}
